// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"620":"9d111627","876":"d83613a0"}[chunkId] + ".chunk.css";
};